var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionInternetAccessFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 8-1.565 1.826a4.009 4.009 0 0 0-.435-.29V8h-6v1.535A3.998 3.998 0 0 0 14 13v6c0 .208.016.413.047.612L12 22 0 8s3-5 12-5 12 5 12 5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10v1a2 2 0 0 1 2 2v1h-2v-1h-2v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2v1h-2v-1a2 2 0 0 1-2-2v-1h2v1h2v-2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2v-1h2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionInternetAccessFee);
export default __webpack_public_path__ + "static/media/ic_action_internet_access_fee.2cde9333b336e8e5535da7d7cc50d642.svg";
export { ForwardRef as ReactComponent };